$(document).ready(myCustomFun);

$(window).on('resize',function() {
  $('.testimonials-slider').slick('refresh');
  $('.cSlider--single').slick('refresh');
  $('.cSlider--nav').slick('refresh');
  $('.featured-product-slider').slick('refresh');
  $('.product__media-list').slick('refresh');
  $('.product__media-nav').slick('refresh');
  $('.review_cont').slick('refresh');
  myCustomFun(false);
});

$(window).on("load", function() {
  $('.product__media-list').slick('refresh');
  $('.PDP_problems_inner').slick('refresh');
  $('.PDP_auth_review_for').slick('refresh');
  myCustomFun(false);
});

function myCustomFun(status=true) {

  if(status){
    if($('.testimonials-slider').length > 0){
      $('.testimonials-slider').slick({
        slidesToShow: 3,
        dots: false,
        arrows: true,
        centerMode: true,
        centerPadding: '0',
        prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path stroke="#F69370" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m10.5 3-5 5 5 5"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path stroke="#F69370" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5.5 13 5-5-5-5"/></svg></button>',
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 993,
            settings: {
              slidesToShow: 1,
              centerMode: false
            }
          }
        ]
      });
    }
    
    if($('.cSlider--single').length > 0){
      $('.cSlider--single').slick({
        slidesToShow: 9,
        slidesToScroll: 1,
        asNavFor: '.cSlider--nav',
        dots: false,
        arrows: false,
        centerMode: true,
        centerPadding: '0',
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 7,
              centerPadding: '25px',
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 3,
              centerPadding: '55px',
            }
          }
        ]
      });

      $('.cSlider--nav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        arrows: true,
        swipeToSlide: false,
        swipe: false,
        asNavFor: '.cSlider--single',
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              swipeToSlide: true,
              swipe: true
            }
          }
        ]
      });
    }
    if($('.featured-product-slider').length > 0){
      $('.featured-product-slider').slick({
        dots: false,
        arrows: true,
        speed: 300,
        slide: '.product-slider-item',
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: false,
        swipe: false,
        infinite: false,
        variableWidth: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              variableWidth: false,
              slidesToShow: 3
            }
          },
          {
            breakpoint: 750,
            settings: {
              swipeToSlide: true,
              swipe: true,
              variableWidth: false,
              slidesToShow: 2
            }
          }
        ]

      }); 

    }
    
    if($('.product__media-list').length > 0) {
      $('.product__media-list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        slide: 'li.product__media-item',
        autoplay: false,
        infinite: true,
        asNavFor: '.product__media-nav',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              adaptiveHeight: true,
              dots: true,
              infinite: true,
              fade: false,
              variableWidth: true
            }
          }
        ]
      });
    }

    if($('.product__media-nav').length > 0) {
      $('.product__media-nav').slick({
        autoplay: false,
        arrows: false,
        dots: false,
        slidesToShow: 8,
        slidesToScroll: 1,
        draggable: true,
        centerPadding: "0px",
        infinite: true,
        vertical: true,
        speed: 1000,
        centerMode: false,
        autoplaySpeed: 2000,
        asNavFor: '.product__media-list',
        useTransform: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        adaptiveHeight: true,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 6,
            }
          },
          {
            breakpoint: 1060,
            settings: {
              slidesToShow: 5,
            }
          }
        ]
      }); 
    }

    if($('.review_cont').length > 0){
      $('.review_cont').slick({
        centerMode: false,
        centerPadding: '0',arrows: false,
        slidesToShow: 1,
        swipeToSlide: false,
        swipe: false,fade:true,
        cssEase:'linear',
        asNavFor: '.review_cont_nav',
        prevArrow: $('.custom-slick-prev'),
        nextArrow: $('.custom-slick-next'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              swipeToSlide: true,
              swipe: true,
              slidesToShow: 1,
              arrows: true
            }
          }
        ]
      });
    $('.review_cont_nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.review_cont',
      dots: true,vertical:true,arrows: false,
      focusOnSelect: true
    });
    }



    var currentUrl = window.location.href;
    if(currentUrl.indexOf('/tools/recurring/') > -1){
      setTimeout(function(){
        instaSlierFun();
        $(".insta-slider").not('.slick-initialized').slick();
      },1000);
    }else{
      instaSlierFun();
    }

  }

  $('.review_cont').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.review_inn').each(function(){
      if($(this).data("slick-index") === currentSlide){
        $(this).find('.modal-content').find('.close').click();
      }
    })
  });
  
  $('.review_cont .slick-arrow').on('click',function(){
    var btnId = $('.review_cont').find('.slick-current').find('.modal_trigger').attr('id');
    $('#'+btnId).trigger("click");
//     document.getElementById(btnId).click();
  });

}

function instaSlierFun(){
  if($('.insta-slider').length > 0){
    $('.insta-slider').slick({
      dots: true,
      arrows: false,
      slidesToShow: 3,
      centerPadding: '25.4%',
      centerMode: true,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            centerPadding: '236px'
          }
        },
        {
          breakpoint: 1200,
          settings: {
            centerPadding: '100px'
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            centerPadding: '20px',
            dots: false
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            centerPadding: '16px',
            dots: false
          }
        }
      ]
    });
  }  
}

$(window).on('resize', function() {
  $('.insta-slider').slick('refresh');
});

// $(document).ready(function(){  
//   setTimeout(function(){
//     $("#status").fadeOut();
//     $("#preloader").delay(500).fadeOut();
//   }, 100);  
// });


$(document).on('keyup','.quantity-input',function(){
  var value = $(this).val();

  if(value > 0) {
    $(this).addClass('form-field-filled');
  } else {
    $(this).removeClass('form-field-filled');
  }
  $(this).parents('.productitem--action').find('.product--quantity').val(value);
});

$(document).on('change','.product-quantity-select',function(){
  var selectedValue = '';
  selectedValue = $(this).find(":selected").val();

  if(selectedValue >= 10 ){
    $(this).parents('.productitem--action').find('.form-field--qty-input').removeClass('hidden');
    $(this).parents('.productitem--action').find('.form-field--qty-select').addClass('hidden');
  }
  $(this).parents('.productitem--action').find('.product--quantity').val(selectedValue);
});

$(document).ready(function(){
  
  $('.clickme').click(function(){
    $('.clickme').removeClass('active');
    $(this).addClass('active');
    var tagid = $(this).data('tag');
    $('.nav_list').removeClass('active').addClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
  });
  var HHeight = $('#shopify-section-header').innerHeight();
  
  // $('body').on('DOMSubtreeModified', '.mega_nav_li.site-mega-nav', function(){
  //   if($(this).find('details.mega_nav_li_details').is("[open]")){
  //     $('body').addClass('body-menu-header');
  //   }else{
  //     $('body').removeClass('body-menu-header');
  //   }
  // });

  // if($( window ).width() > 989){
  //   $('.list-menu__item').on('click',function(){
  //     if($('details.mega_nav_li_details').is("[open]")){
  //       var link = $(this).data('link');
  //       window.location.href = link;
  //     }
  //   });
  // }  

  $('.header__icon--menu').click(function(){
    $('body').addClass('body-menu-open');
  })
  $('.menu-drawer-overlay').click(function(e){
    $('body').removeClass('body-menu-open');
    $('.menu-drawer-container').removeClass('menu-opening');
    $('.menu-drawer-container').removeAttr('open');
  });

  $('.close-menu').click(function(e){
    $('body').removeClass('body-menu-open');
    $('.menu-drawer-container').removeClass('menu-opening');
    $('.menu-drawer-container').removeAttr('open');
  });
  

  /* REMOVED in custom cart removal: cart drawer open/close logic
  $(".shoppingcart").on('click', function() {
    $("body").addClass("CartOpen wc_cart_open");
    return false;
  });
  $(".cart-close").on('click', function() {
    $("body").removeClass("CartOpen wc_cart_open");
    $("body").css("overflow", "visible");
    return false;
  });

  $('body').click(function(e){
    var popup = $(".cart-side-panel");
    if(!$('#cart.shopping-cart').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0){
      if ($("body").hasClass("CartOpen")){
        $("body").removeClass("CartOpen wc_cart_open");
        $("body").css("overflow", "visible");
      }
    }
  });
  */

  $('.faq-card__header').click(function(e) {   
    e.preventDefault();

    var dropDown = $(this).closest('.faq-card').find('.faq-card__body');

    $(this).closest('.faq-section__cards').find('.faq-card__body').not(dropDown).slideUp().attr('aria-expanded', false);

    if($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.faq-section__cards').find('.faq-card__header.active').removeClass('active');
      $(this).addClass('active');
    }

    dropDown.stop(false, true).slideToggle().attr('aria-expanded', function($index, $attr) {
      console.log($attr);
      return ($attr == 'true') ? false : true;
    });
    
    //$('.pro_icon__text_ul').slick('refresh'); 
    //$('.product_ingr_inside_ul').slick('refresh');
    //$('.product_uses_description_row').slick('refresh');  
  });

  
//   var THeight = HHeight + 45;
  $('.scroll_down_btn').click(function(e) {
    e.preventDefault();
    var hrf = $(this).attr("data-href");
    $('html, body').animate({
      'scrollTop' : $(hrf).position().top
    }, 200);
    return false;
  });

  var window_width = $(window).width();
  if(window_width < 750){
    $('.ingredient-title').click(function(e) {

      var dropDown = $(this).closest('.acc__card').find('.ingredient-desc');
      $(this).closest('.accordian-cls').find('.ingredient-desc').not(dropDown).slideUp();

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).closest('.accordian-cls').find('.ingredient-title.active').removeClass('active');
        $(this).addClass('active');
      }

      dropDown.stop(false, true).slideToggle();
      e.preventDefault();
    });
  }
  if(window_width > 749){
    $('.bundle-ingredients-grid .ingredient-title').click(function(e) {
      var dropDown = $(this).closest('.acc__card').find('.ingredient-desc');
      $(this).closest('.accordian-cls').find('.ingredient-desc').not(dropDown).slideUp();

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).closest('.accordian-cls').find('.ingredient-title.active').removeClass('active');
        $(this).addClass('active');
      }

      dropDown.stop(false, true).slideToggle();
      e.preventDefault();
    });
  }
  
  function getandupdateCart() {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      success: function(response){

      },
      error: function(response){
        var cart = JSON.parse(response.responseText);
        if (cart.item_count > 0)
        {
          $('[data-cart-count-bubble]').removeClass('hide');
          $('[data-cart-count]').text(cart.item_count);
        }
      }
    });
  }

  /* REMOVED in custom cart removal: getAjaxCart, upsellSlider2, and legacy Recharge subscription handlers
  var open = false;
  function getAjaxCart() {
    $('.discount-step').load('/cart?view=drawer' + ' .discount-cart-shipping', function(){});
    $('#cart_container_id').load('/cart?view=drawer' + ' .cartDrawer', function(){
      if (open){ $('body').addClass('wc_cart_open'); }
      else{ $('body').removeClass('wc_cart_open'); }
      open = true;
      if ($('#cart_accessories .upsellwrap .upsell_grid').length == 0){ $('#cart_accessories').hide(); }
      else{ upsellSlider2(); }
      $('.cart-content-here').removeClass('wc_cart_loader');
    });
  }
  function upsellSlider2() { ... }
  getAjaxCart();
  function removeCurrentVariant(variant_id) { ... }
  $(document).on('change', '.rc_select_box', function(){ ... });
  $(document).on('change', '.rc_radio_button', function(){ ... });
  */

  var newTab = 0;
  var count = 0;
  var myArray = new Array();  
  $(".add-routine-btn").on( "click",function(){
    var variantId = $(this).data('val');
    var sellId = $(this).data('sell-id');    
    var index = myArray.findIndex((x)=> x.id === $(this).data('val'))
    if(index == -1){
      count++;
      var obj = {
        img: $(this).parents('.product-card').find('.product-image').find('img').attr('src'),
        title : $(this).parents('.product-cms').find('h3').text(),
        review : $(this).parents('.product-cms').find('.review_div').html(),
        id: $(this).data('val'),
        sellid: $(this).data('sell-id'),
        tabId: 'tab'+count
      };      
      if(myArray.length <= 2){
        myArray.push(obj);
      }
      else{
        alert('you can add only 3 products');
      }
    }

    for (let i = 0; i < myArray.length; i++) {
      $('.pro_cnt_'+i).addClass('active');
      $('.add-routine-btn[data-val="'+myArray[i].id+'"]').addClass('disable');
      $('.pro_cnt_'+i).attr('data-vid',myArray[i].id);
      $('.pro_cnt_'+i).attr('data-sell-id',myArray[i].sellid);
      $('.pro_cnt_'+i).find('.product-card img').attr('src',myArray[i].img);
      $('.pro_cnt_'+i).find('.product-cms h5').text(myArray[i].title);
      $('.pro_cnt_'+i).find('.product-cms .pro_review_data').html(myArray[i].review);
      $('.pro_cnt_'+i).find('.remove_item_bundle').removeClass('rib_remove').attr('data-removeid', myArray[i].id);      
      $('.pro_cnt_'+i).find('.remove_item_bundle').attr('data-index', i); 
    }
    
    if($('.routine-list.active').length == 3){
      $('.cart_routine_cls').removeClass('sold_out');      
    }else{
      $('.cart_routine_cls').addClass('sold_out');      
    }
    
//     var windowWidth = $(window).width();
    
//     if(windowWidth < 750){
//       if($('.routine-list.active').length == 3){
//         $('.cart_routine_cls').trigger('click');
//       }
//     }else{
//       console.log('else');
//     }    
  });
  
  
  $(document).on('click','.remove_item_bundle',function(){
    var id = $(this).attr('data-index');
    var removeId = $(this).attr('data-removeid');    
    myArray.splice(id, 1);    
    for (let i = 0; i <= 2; i++) {
      if(myArray[i] && myArray[i].title != ''){             
        $('.pro_cnt_'+i).addClass('active');
        $('.pro_cnt_'+i).attr('data-vid',myArray[i].id);
        $('.pro_cnt_'+i).attr('data-sell-id',myArray[i].sellid);
        $('.add-routine-btn[data-val="'+myArray[i].id+'"]').addClass('disable');
        $('.pro_cnt_'+i).find('.product-card img').attr('src',myArray[i].img);
        $('.pro_cnt_'+i).find('.product-cms h5').text(myArray[i].title);
        $('.pro_cnt_'+i).find('.product-cms .pro_review_data').html(myArray[i].review);
        $('.pro_cnt_'+i).find('.remove_item_bundle').removeClass('rib_remove').attr('data-removeid', myArray[i].id);
      }else{
        let wc_title = '';
        if(i == 0){
          wc_title = 'Step One';
        } else if(i == 1){
          wc_title = 'Step Tow';
        } else{
          wc_title = 'Step Three';
        }
        $('.pro_cnt_'+i).removeClass('active');
        $('.pro_cnt_'+i).attr('data-vid','');
        $('.pro_cnt_'+i).attr('data-sell-id','');
        $('.add-routine-btn[data-val="'+removeId+'"]').removeClass('disable');
        $('.pro_cnt_'+i).find('.product-card img').attr('src','https://cdn.shopify.com/s/files/1/1862/6649/files/icon1.svg?v=1634533065');
        $('.pro_cnt_'+i).find('.product-cms h5').text(wc_title);
        $('.pro_cnt_'+i).find('.product-cms .pro_review_data').html('Add another product to your routine');
        $('.pro_cnt_'+i).find('.remove_item_bundle').addClass('rib_remove').attr('data-removeid','');
      }  
    }    
    if($('.routine-list.active').length == 3){
      $('.cart_routine_cls').removeClass('sold_out');      
    }else{
      $('.cart_routine_cls').addClass('sold_out');      
    }     
  });
  
  $('.bundle_cart_btn_cls').on('click', function(e){
    var $th_button = $(this);
    $('.th_ajax_error').html('');
    $('body').addClass('open_bundle_popup');
    var $bundle_array = new Array();
    $($th_button).parents('.bundle_pro_data').find('.bundle-data').each(function (index, value) {
      var $th_temQTY = $(this).data('qty');
      var $th_temVID = $(this).data('vid');
      var $th_temSellID = $(this).data('sell-id');      
      if($('.custwc_widget__option--subsave').hasClass('custwc_widget__option--active')){
        $bundle_array.push({variant_id: $th_temVID, quantity: $th_temQTY,sell_plan_id: $th_temSellID});      
        console.log('if');
      }else{
        $bundle_array.push({variant_id: $th_temVID, quantity: $th_temQTY});
        console.log('else');
      }
    });    
    $bundle_array.reverse();    
    function product_bundlecart(){
      if($bundle_array.length > 0){
        var $th_request = $bundle_array.shift();
        var $th_tempId = $th_request.variant_id;
        var $th_tempQTY = $th_request.quantity;
        var $th_tempSellId = $th_request.sell_plan_id;
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {"id": $th_tempId, "quantity": $th_tempQTY, "selling_plan": $th_tempSellId,},
          dataType: 'json',
          beforeSend: function(){
            $($th_button).css('font-size','0');
            $($th_button).find('.cart_loader .icon-spinner').show();
          },
          success: function() { 
            product_bundlecart();
            
          },
          error: function(XMLHttpRequest, textStatus) {

          }
        });
      } else {
        $.getJSON('/cart.js', function(cart){
          setTimeout(function(){
            /* REMOVED in custom cart removal: drawer trigger + ajaxCart.load
            $('.shoppingcart').trigger("click");
            ajaxCart.load();
            */
            $($th_button).css('font-size','var(--font-btn-desktop)');
            $($th_button).find('.cart_loader .icon-spinner').hide();
          }, 200);
        });
      }
    }
        product_bundlecart();    
  });

  
  // $(document).on('click', '.cart_routine_cls', function(e){
  //   var $th_button = $(this);
  //   $('.th_ajax_error').html('');
  //   $('body').addClass('open_bundle_popup');
  //   var $th_this_parents = $th_button.parents('.routine-grid');
  //   var $th_id_array = new Array();
  //   jQuery('.routine-list.active').each(function (index, value) {
  //     var $th_temQTY = $(this).data('qty');
  //     var $th_temVID = $(this).data('vid');
  //     var $th_temSellID = $(this).data('sell-id');      
  //     if($th_temSellID == undefined || $th_temSellID == '' ){
  //       $th_id_array.push({variant_id: $th_temVID, quantity: $th_temQTY, properties: {'Routine_Product': 'true'}});
  //     }else{
  //       $th_id_array.push({variant_id: $th_temVID, quantity: $th_temQTY, properties: {'Routine_Product': 'true'},sell_plan_id: $th_temSellID});
  //     }      
  //   });    
  //   $th_id_array.reverse();    
  //   function bundle_addtocart(){     
  //     if($th_id_array.length > 0){        
  //       var $th_request = $th_id_array.shift();        
  //       var $th_tempId = $th_request.variant_id;
  //       var $th_tempQTY = $th_request.quantity;
  //       var $th_tempProperties = $th_request.properties;
  //       var $th_tempSellId = $th_request.sell_plan_id;       
  //       $.ajax({
  //         type: 'POST',
  //         url: '/cart/add.js',
  //         data: {"id": $th_tempId, "quantity": $th_tempQTY, "properties": $th_tempProperties, "selling_plan": $th_tempSellId,},
  //         dataType: 'json',
  //         beforeSend: function(){
  //           $('.cart_routine_cls').css('font-size','0');
  //           $('.cart_loader .icon-spinner').show();
  //         },
  //         success: function() { 
  //           bundle_addtocart();
  //         },
  //         error: function(XMLHttpRequest, textStatus) {            
  //         }
  //       });

  //     } else {
  //       $.getJSON('/cart.js', function(cart){
  //         if(cart.item_count > 0){
  //           setTimeout(function(){                

  //             window.location.href = '/checkout';

  //           }, 200);           
  //         }
  //       });
  //     }
  //   }    
  //   $.ajax({
  //     type: "POST",
  //     url: '/cart/clear.js',
  //     data: '',
  //     dataType: 'json',
  //     success: function() { 
  //       bundle_addtocart();
  //     },
  //     error: function(XMLHttpRequest, textStatus) {
        
  //     }
  //   });
  // });


  $(document).on('click', '.cart_routine_cls', function(e){
    var $th_id_array = [];
    var $th_button = $(this);
    $('.th_ajax_error').html('');
    $('body').addClass('open_bundle_popup');
    var $th_this_parents = $th_button.parents('.routine-grid');
    var $th_id_array_new = [];
    $('.routine-list.active').each(function (index, value) {
      var $th_temQTY = $(this).data('qty');
      var $th_temVID = $(this).data('vid');
      var $th_temSellID = $(this).data('sell-id');   

      if($th_temSellID != undefined || $th_temSellID != '' ){
        $th_id_array_new.push({variant_id: $th_temVID, quantity: $th_temQTY, properties: {'Routine_Product': 'true'},sell_plan_id: $th_temSellID});
      }else{
        $th_id_array_new.push({variant_id: $th_temVID, quantity: $th_temQTY, properties: {'Routine_Product': 'true'}});
      }  
      
    });    

    $th_id_array_new.reverse();  

    if($th_id_array_new.length > 0){
      var proId1 = $th_id_array_new[0].variant_id;
      var proQty1 = $th_id_array_new[0].quantity;
      var proProp1 = $th_id_array_new[0].properties;
      var proSellId1 = $th_id_array_new[0].sell_plan_id;
      
      var proId2 = $th_id_array_new[1].variant_id;
      var proQty2 = $th_id_array_new[1].quantity;
      var proProp2 = $th_id_array_new[1].properties;
      var proSellId2 = $th_id_array_new[1].sell_plan_id;

      var proId3 = $th_id_array_new[2].variant_id;
      var proQty3 = $th_id_array_new[2].quantity;
      var proProp3 = $th_id_array_new[2].properties;
      var proSellId3 = $th_id_array_new[2].sell_plan_id;

      let formData = {
       'items': [
          {
            "id": proId1,
            "quantity": proQty1,
            "properties": proProp1, 
            "selling_plan": proSellId1
          },
          {
            "id": proId2,
            "quantity": proQty2,
            "properties": proProp2, 
            "selling_plan": proSellId2
          },
          {
            "id": proId3,
            "quantity": proQty3,
            "properties": proProp3, 
            "selling_plan": proSellId3
          }
        ]
      };

      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
          $('.cart_routine_cls').css('font-size','0');
          $('.cart_loader .icon-spinner').show();
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            
            if(response.status == 200){
              window.location.href = '/checkout';
            }else{
              console.log('response--',response);
            }
            return response.json();
          })
          .catch((error) => {
            console.log('Error:', error);
          });
        },
        error: function(XMLHttpRequest, textStatus) {
          
        }
      });
    }   
  });
  
});


$(document).on('change', '.single-pro .quantity-selector input[type=radio][name=quantity]', function(){ 
  
  var price = $(this).next('.subscription__button').find('.subscription__price').text().split("/ea").join("");
  var countDis = $(this).next('.subscription__button').find('.subscription__price').data('price');
  var dis_price = (parseFloat(countDis) - ((parseFloat(countDis) * 10) / 100));  
  $('.rc-option__onetime .rc_widget__price--onetime').text(Shopify.formatMoney((countDis / 100).toFixed(2)));
  $('.rc-option__subsave .rc_widget__price--subsave').text(Shopify.formatMoney((dis_price / 100).toFixed(2)));  
  $('.custwc_widget__option--onetime .custwc_widget__price--onetime').text(Shopify.formatMoney((countDis / 100).toFixed(2)));
  $('.custwc_widget__option--subsave .custwc_widget__price--subsave').text(Shopify.formatMoney((dis_price / 100).toFixed(2)));  
  
  var curVal = parseFloat($(this).val());
  var dataTotal = $(this).next('.subscription__button').find('.subscription__price').data('total');
  var dataSubTotal = (parseFloat(countDis) * curVal);
  var saveAmt = parseFloat(dataTotal - dataSubTotal);
  $('.subtotal-qty-price').text(Shopify.formatMoney(dataSubTotal));
  $('.discount-price').text(Shopify.formatMoney(saveAmt));  
  var subChecked = $('.rc-radio__input[type="radio"]:checked');  
  var inputVal = subChecked.val();
  var newVal = $(subChecked).next('.rc-radio__label').find('.rc_widget__price--onetime').text();

  var newDisVal = $(subChecked).next('.rc-radio__label').find('.rc_widget__price--subsave').text();  
  if(inputVal === 'onetime'){
    $(this).next('.subscription__button').find('.subscription__price').text(newVal).append('<sup>/ea</sup>');    
    var countDis = $(this).next('.subscription__button').find('.subscription__price').data('price');
    var dataTotal = $(this).next('.subscription__button').find('.subscription__price').data('total');
    var dataSubTotal = (parseFloat(countDis) * curVal);
    var saveAmt = parseFloat(dataTotal - dataSubTotal);
    $('.subtotal-qty-price').text(Shopify.formatMoney(dataSubTotal));
    $('.discount-price').text(Shopify.formatMoney(saveAmt));    
    // if($(this).val() > 1){
    //   $(this).next('.subscription__button').find('.subscription__price').append('<sup>/ea</sup>');
    //   $('.custwc_widget__option .custwc_widget__price').append('<sup>/ea</sup>');
    // }
  }else if(inputVal === 'subsave'){
    $('.subscription__button').find('.subscription__price').each(function (index, value){
      var countDis = $(this).data('sub-price'); 
      
      var dataTotal = $(this).data('total');
      var dataSubTotal = countDis - ((parseFloat(countDis)));
      
      $(this).text(Shopify.formatMoney(countDis));
    })
    // $(this).next('.subscription__button').find('.subscription__price').text(newDisVal);    
    // var countDis = $(this).next('.subscription__button').find('.subscription__price').data('sub-price');
    // var dataTotal = $(this).next('.subscription__button').find('.subscription__price').data('total');
    // var dataSubTotal = (parseFloat(countDis) * curVal);
    // var saveAmt = parseFloat(dataTotal - dataSubTotal);
    // $('.subtotal-qty-price').text(Shopify.formatMoney(dataSubTotal));
    // $('.discount-price').text(Shopify.formatMoney(saveAmt));    
      $('.subscription__button').find('.subscription__price').append('<sup>/ea</sup>');
      $('.custwc_widget__option .custwc_widget__price').append('<sup>/ea</sup>');
  
  }  

  updateAddToCartPrice();
});

$(document).on('change', '.single-pro .rc-radio__input, .single-pro .rc-radio__input', function(){

  var checked = $('.quantity-selector  input[type=radio]:checked');  
  var subChecked = $('.rc-radio__input[type="radio"]:checked');  
  if ($(checked).is(":checked")) {
    var checkVal = $(checked).next('.subscription__button').find('.subscription__price').text().split("/ea").join("");
    var checkcountDis = $(checked).next('.subscription__button').find('.subscription__price').data('price');
    var checkDisPrice = (parseFloat(checkcountDis) - ((parseFloat(checkcountDis) * 10) / 100));    
    $('.rc-option__onetime .rc_widget__price--onetime').text(Shopify.formatMoney((checkcountDis / 100).toFixed(2)));
    $('.rc-option__subsave .rc_widget__price--subsave').text(Shopify.formatMoney((checkDisPrice / 100).toFixed(2)));    
    $('.custwc_widget__option--onetime .custwc_widget__price--onetime').text(Shopify.formatMoney((checkcountDis / 100).toFixed(2)));
    $('.custwc_widget__option--subsave .custwc_widget__price--subsave').text(Shopify.formatMoney((checkDisPrice / 100).toFixed(2)));        
  }  
  var inputVal = subChecked.val();
  var newVal = $(subChecked).next('.rc-radio__label').find('.rc_widget__price--onetime').text();
  var newDisVal = $(subChecked).next('.rc-radio__label').find('.rc_widget__price--subsave').text();  
  if(inputVal === 'onetime'){
    $(checked).next('.subscription__button').find('.subscription__price').text(newVal);
    if($(checked).val() > 1){
      $(checked).next('.subscription__button').find('.subscription__price').append('<sup>/ea</sup>');
      $('.custwc_widget__option .custwc_widget__price').append('<sup>/ea</sup>');
      
    }    
    var curVal = parseFloat($(checked).val());
    var countDis = $(checked).next('.subscription__button').find('.subscription__price').data('price');
    var dataTotal = $(checked).next('.subscription__button').find('.subscription__price').data('total');
    var dataSubTotal = (parseFloat(countDis) * curVal);
    var saveAmt = parseFloat(dataTotal - dataSubTotal);
    $('.subtotal-qty-price').text(Shopify.formatMoney(dataSubTotal));
    $('.discount-price').text(Shopify.formatMoney(saveAmt));    

    $('.subscription__price').each(function(e){
      var current_data_price = $(this).attr('data-price');
      $(this).text(Shopify.formatMoney(current_data_price)).append('<sup>/ea</sup>');
    })
  }else if(inputVal === 'subsave'){
    $('.subscription__button').find('.subscription__price').each(function (index, value){
      var countDis = $(this).data('sub-price'); 
     
      var dataTotal = $(this).data('total');
      var dataSubTotal = countDis - ((parseFloat(countDis)));
      
      $(this).text(Shopify.formatMoney(countDis));
    })
    // $(checked).next('.subscription__button').find('.subscription__price').text(newDisVal);    
    // var curVal = parseFloat($(checked).val());
    // var countDis = $(checked).next('.subscription__button').find('.subscription__price').data('sub-price');
    // var dataTotal = $(checked).next('.subscription__button').find('.subscription__price').data('total');
    // var dataSubTotal = (parseFloat(countDis) * curVal);
    // var saveAmt = parseFloat(dataTotal - dataSubTotal);    
    // $('.subtotal-qty-price').text(Shopify.formatMoney(dataSubTotal));
    // $('.discount-price').text(Shopify.formatMoney(saveAmt));
    
      $('.subscription__button').find('.subscription__price').append('<sup>/ea</sup>');
      $('.custwc_widget__option .custwc_widget__price').append('<sup>/ea</sup>');


     $('.subscription__price').each(function(e){
      var current_data_price = $(this).attr('data-sub-price');
      $(this).text(Shopify.formatMoney(current_data_price)).append('<sup>/ea</sup>');
    })
    
  }

  updateAddToCartPrice();

  return false;
});

function updateAddToCartPrice() {
  var checked = $('.quantity-selector input[type=radio]:checked');
  var subChecked = $('.rc-radio__input[type="radio"]:checked');
  var price = 0;

  if(subChecked.val() === 'onetime') {
    price = parseFloat(checked.next('.subscription__button').find('.subscription__price').data('price')) * parseFloat(checked.val());
  } else {
    price = parseFloat(checked.next('.subscription__button').find('.subscription__price').data('sub-price')) * parseFloat(checked.val());
  }

  var formattedPrice = Shopify.formatMoney(price).replace('.00', '');
  $('#addtocart-price').html(formattedPrice);
}


$(document).on('change', '.bundle-page .rc-radio__input', function(){  
  var checked = $('.quantity-selector input[type=radio]:checked');  
  var subChecked = $('.rc-radio__input[type="radio"]:checked');  
  var inputVal = subChecked.val();
  var newVal = $(subChecked).next('.rc-radio__label').find('.rc_widget__price--onetime').text();
  var newDisVal = $(subChecked).next('.rc-radio__label').find('.rc_widget__price--subsave').text();  
  if(inputVal === 'onetime'){
    $(checked).next('.subscription__button').find('.subscription__price').text(newVal);
    var countDis = $(checked).next('.subscription__button').find('.subscription__price').data('price');
    var dataTotal = $(checked).next('.subscription__button').find('.subscription__price').data('total');
    var saveAmt = parseFloat(dataTotal - countDis);
    $('.subtotal-qty-price').text(Shopify.formatMoney(countDis));
    $('.discount-price').text(Shopify.formatMoney(saveAmt));    
  }else if(inputVal === 'subsave'){
    $(checked).next('.subscription__button').find('.subscription__price').text(newDisVal);    
    var countDis = $(checked).next('.subscription__button').find('.subscription__price').data('sub-price');
    var dataTotal = $(checked).next('.subscription__button').find('.subscription__price').data('total');    
    var saveAmt = parseFloat(dataTotal - countDis);    
    $('.subtotal-qty-price').text(Shopify.formatMoney(countDis));
    $('.discount-price').text(Shopify.formatMoney(saveAmt));    
  }  
  return false;
});

recursive();
function recursive(){

  var optionsLength = $('.rc_container_wrapper').length;
  if(optionsLength > 0){
    var checked = $('.single-pro .quantity-selector input[type=radio][checked=checked]')
    if ($(checked).is(":checked")) {
      var checkVal = $(checked).next('.subscription__button').find('.subscription__price').text().split("/ea").join("");
      var checkcountDis = $(checked).next('.subscription__button').find('.subscription__price').data('price');
      var checkDisPrice = (parseFloat(checkcountDis) - ((parseFloat(checkcountDis) * 10) / 100));
	  
      $('.rc-option__onetime .rc_widget__price--onetime').text(checkVal);
      $('.rc-option__subsave .rc_widget__price--subsave').text(Shopify.formatMoney((checkDisPrice / 100).toFixed(2)));

      $('.custwc_widget__option--onetime .custwc_widget__price--onetime').text(checkVal);
      $('.custwc_widget__option--subsave .custwc_widget__price--subsave').text(Shopify.formatMoney((checkDisPrice / 100).toFixed(2)));
      
      if($(checked).val() > 1){
        
        $('.custwc_widget__option .custwc_widget__price').append('<sup>/ea</sup>');
          
      }
      
    }  
    $('.custwc-option').removeClass('stop_custm_sell');
    return false;

  }else{
    setTimeout(function(){
      recursive();
    },300);
  }
}

$(document).on('change', '.custwc-template__legacy-radio .custwc-radio .custwc-radio__input', function() {
  $('.custwc-template__legacy-radio .custwc-radio').removeClass('custwc_widget__option--active');
  $('.custwc-template__legacy-radio .custwc-radio').removeClass('custwc-option--active');
  $('.custwc-template__legacy-radio .custwc-radio-group__content').removeClass('custwc-radio-group__content--active');
  $(this).parents('.custwc-radio').addClass('custwc_widget__option--active');
  $(this).parents('.custwc-radio').addClass('custwc-option--active');
  var data_v = $(this).parents('.custwc-radio').data('val');
  $('.'+data_v+' label').trigger('click');
  $('.'+data_v+' .rc-radio__input').trigger('click');

  if(data_v == "rc-option__subsave") {
    $('.custwc_widget__option__plans').css('display' ,'block');
    $('.custwc-template__legacy-radio .custwc-radio-group__content[data-val="rc-option__subsave"]').addClass('custwc-radio-group__content--active');
  } else {
    $('.custwc_widget__option__plans').css('display', 'none');
    $('.custwc-template__legacy-radio .custwc-radio-group__content[data-val="rc-option__onetime"]').addClass('custwc-radio-group__content--active');
  }
});

// wait until recharge has loaded the subscription options before setting the initial value
var rcWidgetInjectionParent = document.querySelector('.rc-widget-injection-parent');
if(rcWidgetInjectionParent !== null) {
  var rcWidgetObserver = new MutationObserver(function(mutations) {
    setTimeout(function() {
      $('#buy-box').removeClass('is-loading');
      $('.custwc-template__legacy-radio .custwc-radio .custwc-radio__input:checked').first().trigger('change');
    }, 350);
  });
  rcWidgetObserver.observe(rcWidgetInjectionParent, {
    attributes:    true,
    childList:     true,
    characterData: true
  });
}

// $(document).ready(function(){
//   $(document).on('click', '.wc_subscription_id', function(){
//   	var id = parseInt($(this).attr('data-subscription-id'));
//     var itemId = parseInt($(this).attr('data-item-id'));
    
//     var lineItem = parseInt($(this).attr('data-line-item'));
//     var lineQty = parseInt($(this).attr('data-item-qty'));

//     var ProductData = {id:itemId,quantity:lineQty,'selling_plan': id};

//     /* Remove product */
//     $.ajax({
//       type: "POST",
//       url: "/cart/change.js",
//       data: "quantity=0&line=" + lineItem,
//       dataType: "json",
//       beforeSend: function() {
//         console.log('remove-before');
//       },
//       success: function(data) {             
//         console.log('remove-success');
//         $.ajax({
//           type: "POST",
//           url: "/cart/add.js",
//           data: ProductData,
//           dataType: "json",
//           beforeSend: function() {
//             /*$('body').addClass('loading');*/
//             console.log('before');
//           },
//           success: function(data) {             
//             console.log('success');
//           },
//           error: function(error) {
//             console.log(error+'fail');        
//           }
//         });
//       },
//       error: function(error) {
//         console.log(error+'fail');        
//       }
//     });
    
//   });
// });

/*------------Product page updated-------------*/

$('.auth_review_for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.auth_review_nav',
   responsive: [
          {
            breakpoint: 849,
            settings: {
              arrows: true,
            }
          }
        ]
});
$('.auth_review_nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.auth_review_for',
  dots: true,
  variableWidth: true,
  focusOnSelect: true
});

$('.PDP_auth_review_for').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  centerMode: true,
  centerPadding:'100px',
   responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          centerMode: true,
          centerPadding:'60px',
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          centerMode: true,
          centerPadding:'100px',
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          centerMode: false,
          centerPadding:'0',
        }
      }
    ]
});

$('.product_ingr_inside_ul').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  variableWidth: true,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
      {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});

$('.PDP_problems_inner').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path stroke="#F69370" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m10.5 3-5 5 5 5"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><path stroke="#F69370" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5.5 13 5-5-5-5"/></svg></button>',
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        arrows: true,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 993,
      settings: {
        arrows: true,
        slidesToShow: 1
      }
    }
  ]
});

$('.pro_icon__text_ul').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
     responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          variableWidth: true,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          variableWidth: false,
          centerPadding:'65.6px'
        }
      }
    ]
});

$('.product_uses_description_row').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
   responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding:'124px'
      }
    }
  ]
});